module.exports = __webpack_public_path__ + "8caad86691424fe5145ad05539079810.jpg";